export const steps = [
    {
        title: "Cadastro",
        content:
        "Economize em dobro! Cadastre-se para receber cashback em suas compras nos sites das lojas parceiras do MeuCupom. São mais de 2 mil lojas onde você poderá economizar aplicando nossos cupons de desconto e recebendo um percentual do valor gasto de volta. Então, não perca mais tempo e faça o seu registro hoje mesmo.",
        image: "https://static.meucupom.com/media/LP%20-%20Devolve/arte1-1.png",
        buttonLabel: "Cadastre-se aqui",
        openModal: true,
    },
    {
        title: "Veja Cupons Disponíveis",
        content:
        "Comprar com cupom de desconto é uma das melhores maneiras de economizar dinheiro em suas compras. Acesse a página da loja de sua preferência e veja os cupons ativos hoje. Obtenha o seu desconto online, utilizando os nossos cupons e garanta parte do valor da sua compra de volta. Comece a aproveitar todas as vantagens que a dobradinha cupom de desconto + cashback oferece!",
        image: "https://static.meucupom.com/media/LP%20-%20Devolve/arte2-1.png",
        buttonLabel: "Lojas parceiras",
        buttonLink: "#lojas-parceiras",
    },
    {
        title: "Ative Seu Cashback",
        content:
        "No MeuCupom, ganhar cashback é fácil e rápido. Ative o MeuCupom Devolve de duas maneiras: faça login após escolher um cupom de desconto na página da loja de sua preferência ou clique no botão “Ativar MeuCupom Devolve e Ir para a Loja”. Não perca tempo e comece a economizar agora mesmo!",
        image: "https://static.meucupom.com/media/LP%20-%20Devolve/arte3-1.png",
        buttonLabel: "Top Cashbacks",
        buttonLink: "https://www.meucupom.com/top-cashback",
    },
    {
        title: "Finalize a sua Compra",
        content:
        "Após pegar o seu cupom, finalize a sua compra no site da loja, que irá abrir automaticamente. É importante que você permaneça na mesma janela de seu navegador e não clique em nenhum outro link antes da conclusão da compra. Isso irá nos ajudar no processo de confirmação e pagamento do seu cashback. Escolha suas categorias favoritas e comece a economizar com o MeuCupom Devolve!",
        image: "https://static.meucupom.com/media/LP%20-%20Devolve/arte4-1.png",
        buttonLabel: "Meus Favoritos",
        buttonLink: "https://www.meucupom.com/perfil/meus-favoritos",
    },
    {
        title: "Confirmação do Cashback",
        content:
        "Pronto! Você receberá um email do MeuCupom Devolve com a identificação do seu cashback em até 5 dias. O prazo de confirmação e pagamento do cashback é de 90 dias, mas não se preocupe. Nós te avisaremos por e-mail quando o seu dinheiro de volta for confirmado e quando o pagamento estiver disponível também.",
        image: "https://static.meucupom.com/media/LP%20-%20Devolve/arte5-1.png",
        buttonLabel: "Verificar meu extrato",
        buttonLink: "/perfil/devolve",
    },
    {
        title: "Receba via Pix",
        content:
        "O MeuCupom Devolve utiliza o PIX como método de pagamento do seu cashback. Por este motivo, é necessário cadastrar uma chave válida em seu perfil. Não perca tempo! Cadastre sua chave PIX e receba seu cashback direto na conta! É fácil, rápido e seguro!",
        image: "https://static.meucupom.com/media/LP%20-%20Devolve/arte6-1.png",
        buttonLabel: "Cadastrar chave PIX",
        buttonLink: "/perfil/devolve",
    },
];